import Koti_Footer from "../components/Koti_Footer";
import Koti_Header from "../components/Koti_Header";
import Koti_NavContainers from "../components/Koti_NavContainers";
import MyDivider from "src/components/layout/MyDivider";

const style = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  gap: 6,
  marginLeft: 8,
  marginRight: 8,
};

export default function KotiLayout() {
  return (
    <div style={style}>
      <Koti_Header />
      <Koti_NavContainers />
      <MyDivider />
      <Koti_Footer />
    </div>
  );
}
